import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormHelperText,
} from "@mui/material";

RHFRadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  helperText: PropTypes.node,
};

export default function RHFRadioGroup({ name, options, helperText, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl component="fieldset" error={!!error} {...other} sx={{ width: "100%","& .MuiFormHelperText-root": {
          color: "red",
          fontSize: "1.2rem", 
          marginLeft: "8px", 
        }, }}>
          <RadioGroup
            {...field}
            row
            value={field.value || ""}
            onChange={(e) => field.onChange(e.target.value)}
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              justifyContent: "space-evenly",
              marginTop: "2rem"
            }}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio 
                
                />}
                label={option.label}
                sx={{
                  "& .MuiTypography-root": {
                    fontSize: "1.6rem",
                  },
                  "& .MuiRadio-root": {
                    color: "#146482",
                    transform: "scale(2)",
                  },
                  "& .Mui-checked": {
                    color: "#146482",
                  }
                }}
              />
            ))}
          </RadioGroup>
          {error ? (
            <FormHelperText>{error.message}</FormHelperText>
          ) : (
            helperText && <FormHelperText>{helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
